import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import "./dashboard.css";

const EmployeeDashboard = () => {
  const [employee, setEmployee] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
    } else {
      fetch("/api/employee", {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        .then((data) => setEmployee(data.employee))
        .catch((err) => console.error("Error fetching employee data:", err));
    }
  }, [navigate]);

  return (
    <div className="dashboard-container">
      <h2>Dashboard Karyawan</h2>
      {employee && <p>Selamat datang, {employee.name}!</p>}

      <button
        className="logout-btn"
        onClick={() => {
          localStorage.removeItem("token");
          navigate("/login");
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default EmployeeDashboard;
